import { formatCurrency } from "@/utils/ranges.util";
import { Area, AreaChart, CartesianGrid, XAxis, YAxis } from "recharts";

import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/atoms/chart";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chartData: any[];
  dataKeyValue: string;
  dataKeyXAxis?: string;
};

const LineChartGradient = ({ chartData, dataKeyValue, dataKeyXAxis }: Props) => {
  const chartConfig = {} satisfies ChartConfig;

  return (
    <ChartContainer config={chartConfig} className="h-[200px] w-full">
      <AreaChart accessibilityLayer data={chartData}>
        <CartesianGrid vertical={true} horizontal={false} />
        <YAxis
          tickCount={3}
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={formatCurrency}
          width={80}
        />
        <XAxis dataKey={dataKeyXAxis} tickLine={false} axisLine={false} tickMargin={8} />
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent formatter={(val) => formatCurrency(val as number)} />}
        />
        <defs>
          <linearGradient id="fillLine" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#1570EF" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#1570EF" stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Area
          type="monotone"
          dataKey={dataKeyValue}
          fill="url(#fillLine)"
          fillOpacity={0.4}
          strokeWidth={2}
          stackId="a"
          className={"bg-fg-brand-primary"}
        />
      </AreaChart>
    </ChartContainer>
  );
};

export default LineChartGradient;
